import { MinimalProject3D } from "./MinimalProject3D";

export const ProjectGrid = ({ projects }) => {
  return <MinimalProject3D projects={projects} />;
};